import { createReducer, on } from '@ngrx/store';
import * as actions from '../actions';
import { IPendingInvitedEmployeesQuickSearchResponse } from '../../../shared/models/shared.model';

export const directorsPendingInvitedBusinessManagementUserQuickSearchFeatureKey =
  'directorsPendingInvitedBusinessManagementUserQuickSearch';

export interface DirectorsPendingInvitedBusinessManagementUserQuickSearchState {
  loadGetDirectorsPendingInvitedBusinessManagementUserResponse: IPendingInvitedEmployeesQuickSearchResponse;
  groupUserRoleIds: string[];
  loadPendingInvitedBusinessManagementUserFailure: Error | any;
  isFirstTimeLoad: boolean;
}

export const initialState: DirectorsPendingInvitedBusinessManagementUserQuickSearchState = {
  loadGetDirectorsPendingInvitedBusinessManagementUserResponse: undefined,
  groupUserRoleIds: undefined,
  loadPendingInvitedBusinessManagementUserFailure: undefined,
  isFirstTimeLoad: true
};

export const reducer = createReducer(
  initialState,

  on(actions.loadDirectorsPendingInvitedBusinessManagementUserQuickSearchSuccess, (state, action) => ({
    ...state,
    loadGetDirectorsPendingInvitedBusinessManagementUserResponse: action.response
  })),
  on(actions.loadDirectorsPendingInvitedBusinessManagementUserQuickSearchFailure, (state, action) => ({
    ...state,
    loadPendingInvitedBusinessManagementUserFailure: action.error
  })),
  on(actions.saveGroupUserRoleIds, (state, action) => ({
    ...state,
    groupUserRoleIds: action.userRoleIds
  })),
  on(actions.clearDirectorsPendingInvitedBusinessManagementUserQuickSearch, (state, action) => ({
    ...state,
    loadGetDirectorsPendingInvitedBusinessManagementUserResponse: undefined
  })),
  on(actions.isDirectorsPendingInvitedFirstTimeLoad, (state, action) => ({
    ...state,
    isFirstTimeLoad: action.firstTimeLoad
  }))
);

export const getDirectorsPendingInvitedBusinessManagementUser = (state: DirectorsPendingInvitedBusinessManagementUserQuickSearchState) =>
  state.loadGetDirectorsPendingInvitedBusinessManagementUserResponse;

export const getSavedGroupUserRoleIds = (state: DirectorsPendingInvitedBusinessManagementUserQuickSearchState) => state.groupUserRoleIds;

export const getDirectorsIsFirstTimeLoad = (state: DirectorsPendingInvitedBusinessManagementUserQuickSearchState) => state.isFirstTimeLoad;
